import React, {useReducer, useEffect} from 'react';
import {useProducerCtx} from '@/views/Layout/b2b/ProducerNavBar/state';

import SearchBox from '@/b2b/pages/Clients/SearchBox';
import ClientsList from '@/b2b/pages/Clients/ClientsList';

import reducer, {getInitialState} from '@/b2b/pages/Clients/state';
import {ClientsCtx} from '@/b2b/contexts';
import {SortLabelHint} from '@/b2b/components/LegendList';

const ClientsContext = ({children}) => {
  const [producer] = useProducerCtx();
  const [state, dispatch] = useReducer(reducer, getInitialState(producer));

  useEffect(
    () => {
      dispatch({
        type: 'changeProducer',
        payload: {
          manager: producer.producerFullName,
          selectedProducerId: producer.producerId,
        },
      });
    },
    [producer]
  );

  return (
    <ClientsCtx.Provider value={[state, dispatch]}>
      {children}
    </ClientsCtx.Provider>
  );
};

const Clients = () => (
  <ClientsContext>
    <SearchBox />
    <SortLabelHint />
    <ClientsList />
  </ClientsContext>
);

export default Clients;
